module.exports = __webpack_public_path__ + "img/sent-rxnt-active-icon-new.cf07591f.svg";